// extracted by mini-css-extract-plugin
module.exports = {"headerLoading":"StageCardLoading_headerLoading__1PkHz","descLoading":"StageCardLoading_descLoading__QWmeK"};